import React from 'react';

//import i18n
import './i18n';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';
import PWAInstallPrompt from './Components/PWAInstallPrompt';

function App() {
  return (
    <React.Fragment>
      <Route />
      <PWAInstallPrompt />
    </React.Fragment>
  );
}

export default App;
